
export default function RemoveSelectedButtonDirective() {
    'ngInject';
    return {
        template: require('./remove-selected-button.html'),
        transclude: true,
        restrict: 'E',
        scope: {
            disabled: '='
        }
    };
}
